<template id="view-printConditions">
  <div class="container-fluid">
    <div
      class="e-dlg-overlay"
      style="z-index: 1002; display: block; position: absolute"
      v-if="dlgShow"
    ></div>
    <div
      id="cardCondiciones"
      :class="{
        'e-control e-dialog e-lib e-dlg-modal e-popup e-popup-open': dlgShow,
        'e-control e-dialog e-lib e-dlg-modal e-popup e-popup-close': !dlgShow
      }"
      role="dialog"
      aria-describedby="conditions-form_dialog-content"
      aria-modal="true"
      aria-labelledby="conditions-form_title"
      tabindex="-1"
      style="z-index: 1003"
    >
      <div class="e-dlg-header-content" id="conditions-form_dialog-header">
        <button
          class="e-dlg-closeicon-btn e-control e-btn e-lib e-flat e-icon-btn"
          type="button"
          title="Close"
          aria-label="Close"
          @click="closeForm"
        >
          <span class="e-btn-icon e-icon-dlg-close e-icons"></span>
        </button>
        <div
          class="e-dlg-header"
          id="conditions-form_title"
          v-text="header"
        ></div>
      </div>
      <div class="e-dlg-content" id="conditions-form_dialog-content">
        <printConditions-form
          ref="printCondForm"
          :formAction="formAction"
          :isMobile="isMobile"
          @formClosed="hideForm"
          @onDataChange="fetchData"
        >
        </printConditions-form>
      </div>
    </div>
    <div class="row top-row">
      <div class="col-12">
        <h3>Condiciones De Impresión</h3>
      </div>
    </div>
    <div class="row">
      <grid-component
        ref="lstGridPrintConditions"
        gridName="PrintConditions"
        :hasRecharge="true"
        @reloadData="reloadData"
        @addNew="addPrintConditions"
        @viewData="viewPrintConditions"
        @editData="updatePrintCondition"
        @deleteData="deletePrintCondition"
      >
      </grid-component>
    </div>
    <div class="row" v-show="dlgShow"></div>
  </div>
</template>

<script>
/*Imports de VueJS*/
import Vue from "vue";

import { FormActionEnum } from "../../services/enums.js";
import GridComponent from "../shared/GridComponent.vue";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
//import CondicionesForm from "./CondicionesForm.vue";
import PrintConditionsForm from "./PrintConditionsForm.vue";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
// import CultureMixin from "../../mixins/CultureMixin";

/*Imports de Syncfusion*/
import { Browser } from "@syncfusion/ej2-base";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { DialogUtility } from "@syncfusion/ej2-popups";
import { TooltipPlugin } from "@syncfusion/ej2-vue-popups";

Vue.use(ButtonPlugin);
Vue.use(TooltipPlugin);
Vue.use(DialogPlugin);

export default Vue.extend({
  name: "PrintConditions",
  props: {},
  mixins: [PermissionMixin, ToastMixin],
  components: { GridComponent, PrintConditionsForm },
  created() {
    this.formAction = FormActionEnum.LIST;
  },
  showLoading() {
    console.log("Llamando a showLoading PrintConditions");
    this.$parent.showLoading();
  },
  hideLoading(timeout = 2000) {
    console.log("Llamando a hideLoading PrintConditions");
    this.$parent.hideLoading(timeout);
  },

  async mounted() {
    this.$parent.showLoading();
    this.$refs.lstGridPrintConditions.clearDataGrid();

    var MacroRamos = await this.$store.dispatch(
      "printConditions/getTableData",
      {
        schema: "param",
        name: "MacroRamos"
      }
    );
    this.macroLines = JSON.parse(JSON.stringify(MacroRamos.data));

    var Ramos = await this.$store.dispatch("printConditions/getTableData", {
      schema: "param",
      name: "ramos"
    });
    this.lines = JSON.parse(JSON.stringify(Ramos.data));

    var Suc = await this.$store.dispatch("printConditions/getTableData", {
      schema: "param",
      name: "Sucursales"
    });
    this.branchOffices = JSON.parse(JSON.stringify(Suc.data));

    var UnidadesComerciales = await this.$store.dispatch(
      "printConditions/getTableData",
      {
        schema: "param",
        name: "UnidadesComerciales"
      }
    );
    this.businessUnits = JSON.parse(JSON.stringify(UnidadesComerciales.data));

    var GrupoEndoso = await this.$store.dispatch(
      "printConditions/getTableData",
      {
        schema: "param",
        name: "GruposEndosos"
      }
    );
    this.endorsementsTypes = JSON.parse(JSON.stringify(GrupoEndoso.data));

    var TiposEndosos = await this.$store.dispatch(
      "printConditions/getTableData",
      {
        schema: "param",
        name: "TiposEndosos"
      }
    );
    this.endorsementSubTypes = JSON.parse(JSON.stringify(TiposEndosos.data));

    await this.fetchData();
    await this.$store.dispatch("packages/getPackages");
    await this.$store.dispatch("documents/getDocuments");
    await this.$store.dispatch("formats/getFormats");
    await this.$store.dispatch("integrations/getIntegrations");
    this.$parent.hideLoading(500);
  },
  updated() {},

  computed: {
    header() {
      if (this.formAction === FormActionEnum.ADD) {
        return "Nueva Condición";
      }
      if (this.formAction === FormActionEnum.VIEW) {
        return "Consultar Condición";
      }
      if (this.formAction === FormActionEnum.EDIT) {
        return "Modificar Condición";
      }
      if (this.formAction === FormActionEnum.DELETE) {
        return "Deshabilitar Condición";
      }
      return "";
    },
    rowData() {
      return this.$store.getters["printConditions/currentPrintCondition"];
    },
    formData() {
      return JSON.parse(JSON.stringify(this.rowData));
    }
  },
  data() {
    return {
      dlgShow: false,
      formAction: FormActionEnum.LIST,
      isMobile: Browser.isDevice,
      deleteDialog: {},
      toolTip: "",
      filter: { type: "CheckBox" },
      selectionSettings: { persistSelection: true },
      fields: { text: "name", value: "id" },
      query: "",
      dataList: [],
      macroLines: null,
      lines: null,
      branchOffices: null,
      businessUnits: null,
      endorsementsTypes: null,
      endorsementSubTypes: null
    };
  },
  provide: {},
  methods: {
    printConditionsList() {
      var instance = this;
      var list = this.$store.getters["printConditions/allPrintConditions"];
      if (list && list.length > 0) {
        return list.map(function (x) {
          var item = x;
          item.macroLine = instance.getMacroLineFromId(
            instance.macroLines,
            item.macroLineId
          );

          if (item.lineId == null) {
            item.Line = null;
          } else {
            item.Line = instance.getLineFromId(instance.lines, item.lineId);
          }

          if (item.branchOfficeId == null) {
            item.branchOffice = null;
          } else {
            item.branchOffice = instance.getBranchOfficeFromId(
              instance.branchOffices,
              item.branchOfficeId
            );
          }

          if (item.businessUnitId == null) {
            item.businessUnit = null;
          } else {
            item.businessUnit = instance.getBusinessUnitFromId(
              instance.businessUnits,
              item.businessUnitId
            );
          }

          if (item.endorsementTypeId == null) {
            item.endorsementType = null;
          } else {
            item.endorsementType = instance.getEndorsementTypeFromId(
              instance.endorsementsTypes,
              item.endorsementTypeId
            );
          }

          if (item.endorsementSubTypeId == null) {
            item.endorsementSubType = null;
          } else {
            item.endorsementSubType = instance.getEndorsementSubTypeFromId(
              instance.endorsementSubTypes,
              item.endorsementSubTypeId
            );
          }

          item.activeName = item.isActive ? "Activo" : "Inactivo";

          return item;
        });
      }
      return list;
    },
    getItemNameFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.id == id);
          if (item != null && item != undefined) {
            return item.name;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getMacroLineFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdMacroRamo == id);
          if (item != null && item != undefined) {
            return item.DescMacroramo;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getLineFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdRamo == id);
          if (item != null && item != undefined) {
            return item.DescRamo;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getBranchOfficeFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.CodigoSucursal == id);
          if (item != null && item != undefined) {
            return item.DescSucursal;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getBusinessUnitFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdUnidadComercial == id);
          if (item != null && item != undefined) {
            return item.DescUnidadComercial;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getEndorsementTypeFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdGrupoEndoso == id);
          if (item != null && item != undefined) {
            return item.DescGrupodeEndoso;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getEndorsementSubTypeFromId(list, id) {
      try {
        var hasItems = list && list.length > 0;
        if (hasItems) {
          var item = list.find((x) => x.IdTipoEndoso == id);
          if (item != null && item != undefined) {
            return item.DescTipoEndoso;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async reloadData() {
      //this.$refs.lstGridPrintConditions.clearDataGrid();
      this.$parent.showLoading();
      await this.fetchData();
      this.$parent.hideLoading(500);
    },
    async fetchData() {
      //this.$refs.lstGridFormatos.clearDataGrid();
      this.$store.dispatch("printConditions/initPrintCondition");
      await this.$store.dispatch("printConditions/getPrintConditions");
      this.dataList = this.printConditionsList();
      //this.macroLinesList();
      this.$refs.lstGridPrintConditions.setGridData(
        this.dataList,
        this.columnsList()
      );
    },
    columnsList() {
      let arrayColumns = [
        {
          field: "isActive",
          type: "boolean",
          displayAsCheckBox: "true",
          visible: false
        },
        {
          field: "activeName",
          headerText: "Activo",
          width: "150",
          minWidth: "150"
        },
        { field: "macroLineId", headerText: "Macro Ramo", visible: false },
        { field: "macroLine", headerText: "Macro Ramo", visible: true },
        { field: "lineId", headerText: "Ramo", visible: false },
        {
          field: "Line",
          headerText: "Ramo",
          visible: true,
          clipMode: "EllipsisWithTooltip"
        },
        { field: "branchOfficeId", headerText: "Sucursal", visible: false },
        {
          field: "branchOffice",
          headerText: "Sucursal",
          visible: true,
          clipMode: "EllipsisWithTooltip"
        },
        {
          field: "businessUnitId",
          headerText: "Unidad Comercial.",
          visible: false
        },
        {
          field: "businessUnit",
          headerText: "Unidad Comercial.",
          visible: true,
          clipMode: "EllipsisWithTooltip"
        },
        {
          field: "endorsementTypeId",
          headerText: "Grupo Endoso",
          visible: false
        },
        {
          field: "endorsementType",
          headerText: "Grupo Endoso",
          visible: true,
          clipMode: "EllipsisWithTooltip"
        },
        {
          field: "endorsementSubTypeId",
          headerText: "Tipo Endoso",
          visible: false
        },
        {
          field: "endorsementSubType",
          headerText: "Tipo Endoso",
          visible: true,
          clipMode: "EllipsisWithTooltip"
        },
        { field: "agentId", headerText: "Intermediario" },
        // { field: "productId", headerText: "Cod.Producto" },
        { field: "holderId", headerText: "Cod.Tomador" },
        {
          headerText: "Acciones",
          commands: JSON.parse(JSON.stringify(this.commands))
        }
      ];

      return arrayColumns;
    },
    async addPrintConditions() {
      // this.dlgShow = !this.dlgShow;
      // var newPrintCondition = {
      //   isNew: true,
      //   conditionId: 0,
      //   companyId: null,
      //   macroLineId: null,
      //   lineId: null,
      //   branchOfficeId: null,
      //   businessUnitId: null,
      //   endorsementTypeId: null,
      //   endorsementSubTypeId: null,
      //   productId: 0,
      //   agentId: 0,
      //   holderId: 0,
      //   validFrom: "",
      //   validThru: "",
      //   policyNumber: 0,
      //   printEnabled: false,
      //   isActive: false
      // };

      this.formAction = FormActionEnum.ADD;
      //this.showForm(newPrintCondition);
      await this.$store.dispatch("printConditions/initPrintCondition");
      var data = this.$store.getters["printConditions/currentPrintCondition"];
      this.showForm(data);
    },
    viewPrintConditions(rowData) {
      this.formAction = FormActionEnum.VIEW;
      this.showForm(rowData);
    },
    updatePrintCondition(rowData) {
      this.formAction = FormActionEnum.EDIT;
      this.showForm(rowData);
    },
    deletePrintCondition(rowData) {
      let hasRowData = !!rowData;
      if (hasRowData) {
        rowData.active = false;
        this.getDeleteConfirmation(rowData);
      }
    },
    async InactivateRow() {
      try {
        var localData = JSON.parse(JSON.stringify(this.deleteDialog.data));
        localData.isActive = false;

        await this.$store.dispatch(
          "printConditions/deletePrintCondition",
          localData
        );

        this.fetchData();
        this.showToast(
          "Confirmación",
          `Condicion de impresion desactivada`,
          2000
        );
      } catch (error) {
        this.showToast("Error", error.message, 2000);
      }
      this.deleteDialog.data = {};
      this.deleteDialog.hide();
    },
    getDeleteConfirmation(row) {
      this.deleteDialog = DialogUtility.confirm({
        title: "Desactivar condición de impresión",
        zindex: 1010,
        content: `Confirma que desea desactivar condición de impresión`,
        okButton: {
          text: "desactivar",
          click: this.InactivateRow,
          isPrimary: true
        },

        cancelButton: { text: "Cancelar" },
        showCloseIcon: false,
        closeOnEscape: false,
        animationSettings: { effect: "Zoom" }
      });
      this.deleteDialog.data = row;
      this.deleteDialog.show();
    },
    getAlertDialog(title, content) {
      let dialog = DialogUtility.alert({
        title: title,
        zindex: 1010,
        content: content,
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" }
      });
      return dialog;
    },
    showForm(data) {
      try {
        let hasData = !!data;
        if (hasData) {
          this.$store.dispatch("printConditions/setPrintCondition", data);
        }
      } catch (error) {
        console.log(error);
      }

      this.$refs.printCondForm.setFormData(this.formData, this.formAction);
      this.$refs.printCondForm.loadComponent();
      this.dlgShow = true;
    },
    // onDialogClose() {
    //   this.dlgShow = false;
    //   console.log("close");
    // },
    // onDialogOpen() {
    //   this.dlgShow = true;
    //   console.log("open");
    // },

    closeForm() {
      this.$refs.printCondForm.unloadComponent();
    },
    hideForm() {
      this.dlgShow = false;
    }
  }
});
</script>
<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-notifications/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-inputs/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-popups/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-navigations/styles/fabric.css);
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);
@import url(../form-icons.css);

.e-alert-dialog.e-dialog.e-popup,
.e-confirm-dialog.e-dialog.e-popup {
  margin: auto !important;
}
.content-wrapper {
  width: 100%;
  margin: 15px auto;
  min-width: 185px;
}
@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
}
.e-add-icon {
  background-repeat: no-repeat;
}
#conditions-form {
  width: 100%;
  height: 100%;
}

#dialogCondiciones,
#cardCondiciones {
  position: fixed;
  top: 60px;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
</style>
